import { createFileRoute, notFound } from "@tanstack/react-router";

import LandingNotFound from "@/components/landing/LandingNotFound";
import LandingPageView from "@/components/landing/LandingPageView";
import { landingPageContent } from "@/content/landing/source";
import { cmsPageHead, cmsPageHeaders } from "@/routing/cmsPageRoute";

export const Route = createFileRoute("/use-cases/")({
  loader: async () => {
    const page = await landingPageContent({ data: "/use-cases" });
    if (!page) {
      throw notFound();
    }
    return page;
  },
  headers: cmsPageHeaders,
  head: cmsPageHead,
  component: UseCaseIndexRoute,
  notFoundComponent: LandingNotFound,
});

function UseCaseIndexRoute() {
  return <LandingPageView page={Route.useLoaderData()} />;
}
